"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Aviation", {
  enumerable: true,
  get: function () {
    return _aviation.loader;
  }
});
Object.defineProperty(exports, "Breakpoints", {
  enumerable: true,
  get: function () {
    return _breakpoints.loader;
  }
});
Object.defineProperty(exports, "FlightRules", {
  enumerable: true,
  get: function () {
    return _flightrules.loader;
  }
});
Object.defineProperty(exports, "Invests", {
  enumerable: true,
  get: function () {
    return _invests.loader;
  }
});
Object.defineProperty(exports, "Routing", {
  enumerable: true,
  get: function () {
    return _routing.loader;
  }
});
Object.defineProperty(exports, "Sigmets", {
  enumerable: true,
  get: function () {
    return _sigmets.loader;
  }
});
Object.defineProperty(exports, "StationPlots", {
  enumerable: true,
  get: function () {
    return _stationplots.loader;
  }
});
Object.defineProperty(exports, "Systems", {
  enumerable: true,
  get: function () {
    return _systems.loader;
  }
});
Object.defineProperty(exports, "Tropical", {
  enumerable: true,
  get: function () {
    return _tropical.loader;
  }
});
Object.defineProperty(exports, "TropicalUtils", {
  enumerable: true,
  get: function () {
    return _tropical.utils;
  }
});
Object.defineProperty(exports, "Windfields", {
  enumerable: true,
  get: function () {
    return _windfields.loader;
  }
});
var _flightrules = require("./aviation/flightrules");
var _sigmets = require("./aviation/sigmets");
var _stationplots = require("./aviation/stationplots");
var _systems = require("./tropical/systems");
var _invests = require("./tropical/invests");
var _windfields = require("./tropical/windfields");
var _breakpoints = require("./tropical/breakpoints");
var _routing = require("./routing");
var _aviation = require("./aviation");
var _tropical = require("./tropical");